import { periods, frequencyIds, LOCATION_ENTITY_NAME } from '../models';


const buildEmailReport = (state, selectedEmailReport = null, additionalConfig = {}) => {
  const {
    frequency, interval, sendoutTime, date, LocationId, ReportId, EmailTo, period, StartOffset,
  } = state;

  const selectedPeriod = periods.find(p => p.id === period);
  const config = {
    ...JSON.parse(selectedEmailReport?.config || '{}'),
    LocationId,
    ReportId,
    EmailTo,
    Duration: selectedPeriod.duration,
    StartOffset,
    ...(selectedPeriod.additionalOptions || {}),
    ...additionalConfig,
  };

  const newEmailReport = {
    ...selectedEmailReport || {},
    frequency,
    interval,
    sendoutTime,
    nextSendout: frequency === frequencyIds.once
      ? `${date.format('YYYY-MM-DD')}T${sendoutTime}:00` : selectedEmailReport?.nextSendout,
    config: JSON.stringify(config),
    entityName: LOCATION_ENTITY_NAME,
    entityId: LocationId,
  };

  return newEmailReport;
};

export default buildEmailReport;
